<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 30%"
          v-model="searchParams.postIds"
          placeholder="请输入帖子ID"
          clearable
        ></el-input>
        <!-- <el-input style="width: 20%" v-model="searchParams.communityIds" placeholder="请输入圈子ID" clearable></el-input> -->
        <el-input
          style="width: 30%"
          v-model="searchParams.titleKeyword"
          placeholder="请输入帖子标题关键字"
          clearable
        ></el-input>
        <el-input
          style="width: 30%"
          v-model="searchParams.contentKeyword"
          placeholder="请输入帖子全文关键字"
          clearable
        ></el-input>
        <div style="width: 40%">
          计划推送时间:
          <el-date-picker
            style="width: 80%"
            v-model="searchParams.expectPushDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="width: 40%">
          实际推送时间：
          <el-date-picker
            style="width: 80%"
            v-model="searchParams.pushDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <div>
        <el-button type="primary" @click="handleInitAddPost">
          新增帖子
        </el-button>
        <el-button type="primary" @click="onMultiImport"> 批量导入 </el-button>
      </div>
    </div>
    <!-- 批量导入弹窗 -->
    <el-dialog title="批量导入" :visible.sync="dialogMultiImport" width="400px">
      <div v-if="dialogMultiImport">
        <input
          type="file"
          @change="fileChange"
          ref="file"
          style="margin-bottom: 20px"
        />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadCategoryExl"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
        <el-button size="medium" @click="downloadCategoryExl">
          下载最新模板
        </el-button>
      </div>
    </el-dialog>
    <!-- 筛选框 -->
    <div class="content-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <!-- <span>{{ allCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
            ref="table"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="未推送" name="unpushed">
          <span slot="label" class="slot-item">
            <span>未推送</span>
            <!-- <span>{{ unAuditCount }}</span> -->
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
            ref="table"
          ></circle-table>
        </el-tab-pane>
        <el-tab-pane label="已推送" name="pushed">
          <span slot="label" class="slot-item">
            <span>已推送</span>
          </span>
          <circle-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
            :mulSelect="false"
            ref="table"
          ></circle-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <!-- 查看详情 -->
    <el-drawer
      :visible.sync="dialogSetCircle"
      direction="rtl"
      size="40%"
      :destroy-on-close="true"
    >
      <div class="header-container">
        <div class="header">帖子详情</div>
      </div>
      <div style="margin-top: 10px" class="form-container">
        <el-form
          :model="circleForm"
          :rules="circleRules"
          ref="circleForm"
          label-width="160px"
        >
          <!-- 帖子ID -->
          <el-form-item label="帖子ID">
            {{ circleForm.postId }}
          </el-form-item>

          <!-- 帖子审核状态 -->
          <el-form-item label="帖子状态">
            {{ circleForm.auditStatus == 0 ? "待审核" : null }}
            {{ circleForm.auditStatus == 1 ? "审核通过" : null }}
            {{ circleForm.auditStatus == 2 ? "审核拒绝" : null }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="发布者">
            {{ circleForm.nickName }}
          </el-form-item>

          <!-- 发布者 -->
          <el-form-item label="用户pin">
            {{ circleForm.pin }}
          </el-form-item>

          <!-- 用户发布时间 -->
          <el-form-item label="发布时间">
            {{ formatDate(circleForm.submitTime) }}
          </el-form-item>

          <!-- 所属圈子名称 -->
          <el-form-item label="所属圈子" v-if="!communityOptionsVisible">
            {{ circleForm.communityName }}
          </el-form-item>

          <!-- 标题 -->
          <el-form-item label="帖子标题">
            {{ circleForm.title }}
          </el-form-item>

          <!-- 正文 -->
          <el-form-item label="帖子正文">
            {{ circleForm.content }}
          </el-form-item>
          <!-- 康康回复内容 -->
          <el-form-item label="康康回复内容">
            <div v-if="KKCommentInputShow">
              <el-input
                size="small"
                type="textarea"
                v-model="circleForm.kangkangComment"
                maxlength="200"
                show-word-limit
                class="freezeInp"
              >
              </el-input>
              <el-button type="text" @click="handleEditKKComment"
                >确认</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKCommentInputShow = false;
                    this.circleForm.kangkangComment = this.KKCommentTemp;
                    this.KKCommentTemp = '';
                  }
                "
                >取消</el-button
              >
            </div>
            <div v-else>
              {{ circleForm.kangkangComment }}
              <!-- <el-button type="text" @click="() => {
                this.KKCommentInputShow = true;
                this.KKCommentTemp = this.circleForm.kangkangComment
              }">修改</el-button> -->
            </div>
          </el-form-item>

          <!-- 康康追问 -->
          <el-form-item label="康康追问">
            <div v-if="KKQuestionInputShow">
              <el-input
                size="small"
                type="textarea"
                v-model="circleForm.kangkangQuestion"
                maxlength="200"
                show-word-limit
                class="freezeInp"
              >
              </el-input>
              <el-button type="text" @click="handleEditKKComment"
                >确认</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.KKQuestionInputShow = false;
                    this.circleForm.kangkangQuestion = this.KKQuestionTemp;
                    this.KKQuestionTemp = '';
                  }
                "
                >取消</el-button
              >
            </div>
            <div v-else>
              {{ circleForm.kangkangQuestion }}
              <!-- <el-button type="text" @click="() => {
                this.KKQuestionInputShow = true
                this.KKQuestionTemp = this.circleForm.kangkangQuestion
              }">修改</el-button> -->
            </div>
          </el-form-item>

          <!-- 康康高亮词 -->
          <el-form-item label="康康高亮词">
            {{ circleForm.kangkangHighlightWords }}
          </el-form-item>

          <!-- 小图 -->
          <el-form-item label="图文视频" label-width="160px" prop="imageUrl">
            <div class="image-flex" v-if="circleForm.contentPicUrl">
              <div
                v-for="(url, index) in JSON.parse(circleForm.contentPicUrl)"
                :key="index"
                class="image-item"
              >
                <img
                  :src="
                    url.startsWith(imgHost) ||
                    url.startsWith('http://storage.jd.local') ||
                    url.startsWith('https') ||
                    url.startsWith('http') ||
                    url.startsWith('https://jkimg10.360buyimg.com') ||
                    url.startsWith('https://storage.360buyimg.com')
                      ? url
                      : `${imgHost}${url}`
                  "
                  alt="图片"
                  @click="handleImageClick(url)"
                />
                <div class="image-overlay">
                  <el-button
                    @click="
                      viewImage(
                        url.startsWith(imgHost) ||
                          url.startsWith('http://storage.jd.local') ||
                          url.startsWith('https') ||
                          url.startsWith('http') ||
                          url.startsWith('https://jkimg10.360buyimg.com') ||
                          url.startsWith('https://storage.360buyimg.com')
                          ? url
                          : `${imgHost}${url}`
                      )
                    "
                    type="primary"
                    icon="el-icon-zoom-in"
                    size="mini"
                  ></el-button>
                </div>
              </div>
            </div>
            <div v-else>暂无图片</div>
            <div class="image-flex" v-if="circleForm.postVideoInfo">
              <video
                ref="videoPlayer"
                :src="circleForm.postVideoInfo.playUrl"
                controls
                style="width: 100%"
              ></video>
            </div>
          </el-form-item>
          <!-- 敏感 -->
          <el-form-item label="是否含敏感内容">
            {{
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
                ? "是"
                : "否"
            }}
          </el-form-item>
          <!-- 敏感内容 -->
          <el-form-item
            v-if="
              circleForm?.postExtDTO?.sensitiveWordInfo ||
              circleForm?.postExtDTO?.isImageSensitiveWord ||
              circleForm?.postExtDTO?.isImagePorn
            "
            label="所含敏感内容"
          >
            <div v-if="circleForm?.postExtDTO?.sensitiveWordInfo">
              <span>敏感词信息:</span>
              {{ circleForm?.postExtDTO?.sensitiveWordInfo }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImageSensitiveWord"
              style="margin-left: 20px"
            >
              <span>图片包含敏感词:</span>
              {{ circleForm?.postExtDTO?.isImageSensitiveWord ? "是" : "否" }}
            </div>
            <div
              v-if="circleForm?.postExtDTO?.isImagePorn"
              style="margin-left: 20px"
            >
              <span>图片包含涉黄信息:</span>
              {{ circleForm?.postExtDTO?.isImagePorn ? "是" : "否" }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="dialogSetCircle = false">关闭</el-button>
      </div>
    </el-drawer>
    <!-- 新增 -->
    <el-drawer
      :visible.sync="dialogAddPost"
      direction="rtl"
      size="50%"
      :destroy-on-close="true"
    >
      <div class="header-container">
        <div class="header">
          {{ dialogEditCircle ? "编辑帖子" : "新增帖子" }}
        </div>
      </div>
      <div style="margin-top: 10px; margin-left: 30px" class="form-container">
        <div
          style="
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <span style="width: 30%"
            ><span style="color: red">*</span>帖子ID：</span
          >
          <el-input
            style="flex: 1"
            v-model="addPostId"
            placeholder="请输入帖子ID"
            clearable
            :disabled="dialogEditCircle"
          ></el-input>
          <el-button @click="handleAddPostIdSearch">搜索</el-button>
        </div>
        <div
          style="
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="width: 30%">计划推送时间：</div>
          <el-date-picker
            v-model="addPostExpectedPushTime"
            type="date"
            placeholder="请选择期望上传时间"
            clearable
            style="flex: 1"
            :pickerOptions="addPostDatePickerOpt"
          ></el-date-picker>
        </div>

        <el-table
          ref="addPostIdSearch"
          :data="addPostIdSearch"
          style="width: 100%"
        >
          <el-table-column prop="postId" label="帖子ID"></el-table-column>
          <el-table-column prop="title" label="帖子标题"></el-table-column>
          <el-table-column prop="createUser" label="发布者ID"></el-table-column>
          <el-table-column prop="status" label="帖子状态">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === 1
                  ? "审核通过"
                  : scope.row.status === 2
                  ? "审核拒绝"
                  : "待审核"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="submitTime" label="发布时间" width="180">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.submitTime) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="margin-top: 10px; margin-left: 30px"
        class="form-container"
      ></div>
      <div class="drawer-footer">
        <el-button
          @click="
            () => {
              dialogAddPost = false;
              getArticleList();
            }
          "
          >关闭</el-button
        >
        <el-button @click="handleAddPost">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import utils from "../../../../../utils";
import circleTable from "./circleTable.vue";
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import { fileChange } from "../../../../man/components/importExportCommon.js";
import { manListUserConfig, jdh_qz_man_widget_post_import } from "@/api/man";
import {
  jdh_qz_man_widget_post_page,
  jdh_qz_man_widget_post_update,
  jdh_qz_man_post_page,
} from "../../../../../api/community";
import modal from "@/components/modal";
import baseDialog from "../../../components/baseDialog";
import { request } from "@/utils/axios";
import { mapState } from "vuex";
import uploadImage from "@/components/uploadImage";
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import GenericNameLabel from "@/components/combination/GenericNameLabel";
import UploadVideo from "@/components/combination/UploadVideo";
export default {
  name: "goTopManage",
  data() {
    return {
      businessChannelArr: [], // 天空之城
      activeName: "all",
      selectedRows: [],
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "帖子ID",
            prop: "postId",
            width: "180px",
          },
          {
            label: "帖子名称",
            prop: "title",
            width: "200px",
          },
          {
            label: "帖子正文",
            prop: "content",
            width: "250px",
          },
          {
            label: "所属圈子",
            prop: "communityName",
          },
          {
            label: "帖子类型",
            prop: "communityPostTypeName",
          },
          {
            label: "推送状态",
            prop: "modStatus",
          },
          {
            label: "推送次数",
            prop: "pushNum",
          },
          {
            label: "计划推送时间",
            prop: "expectPushDate",
          },
          {
            label: "推送时间",
            prop: "modPushTime",
          },
        ],
        tableType: 222,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20],
      },
      // 批量上传
      fileList: [],
      dialogContentVisible: false,
      // 新建圈子
      dialogSetCircle: false,
      // 增加主视频
      dialogAddVideo: false,
      // 编辑
      dialogEditCircle: false,
      circleForm: {
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        title: "",
        hotValue: "",
        content: "",
        communityType: "",
        pin: "",
        contentPicUrlList: [],
        contentPicUrl: "",
        isTopicTop: "",
        communityName: "",
        communityId: "",
        class: "",
        avatarUrl: "",
        nickName: "",
        auditor: "",
        updateUser: "",
        updateTime: "",
        postId: "",
        submitTime: "",
        isCommunityTop: "",
        auditTime: "",
        createTime: "",
        tenantId: parseInt(this.$route.query.tenantid),
        authorIp: "",
        auditStatus: "",
        createUser: "",
        isAutoAudit: "",
        status: "",
        realyName: "",
      },
      circleRules: {
        // name: [
        //   { required: true, message: '请输入圈子名称', trigger: 'blur' }
        // ],
        // imageUrl: [
        //   { required: true, message: '请上传圈子小图', trigger: 'change' }
        // ],
        // type: [
        //   { required: true, message: '请选择圈子类型', trigger: 'change' }
        // ],
        // features: [
        //   { required: true, type: 'array', min: 1, message: '请选择至少一个功能', trigger: 'change' }
        // ]
      },
      titlePicUrl: [],
      dialogVisible: false,
      searchParams: {
        communityName: "",
        communityIds: this.$route.query.circleId || "",
        communityType: "",
        auditStatus: "",
      },
      showMultiSelect: false,
      communityOptions: [],
      dialogAddPost: false,
      addPostId: "",
      addPostExpectedPushTime: "",
      addPostIdSearch: [],
      uploadShow: false,
      dialogMultiImport: false,
      dialogMultiExport: false,
      addPostDatePickerOpt: {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          return time < tomorrow;
        },
      },
    };
  },
  components: {
    // search,
    manFormList,
    breadCrumb,
    circleTable,
    pagination,
    modal,
    baseDialog,
    uploadPosterImage,
    uploadImage,
    uploadImgUniversal,
    GenericNameLabel,
    UploadVideo,
  },
  async created() {
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    if (this.$route.query.circleId) {
      const circleId = this.$route.query.circleId;
      this.handleInitSearch(circleId);
    }
    this.handleInitSearch();
  },
  mounted() {
    this.$nextTick(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    });
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("content");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    onMultiImport() {
      console.log("==== onMultiImport");
      this.dialogMultiImport = true;
      this.fileName = null;
    },
    // 切换tab
    handleClick(tab, event) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      // this.getArticleList()
      if (this.activeName === "all") {
        this.searchParams.status = "";
      } else if (this.activeName === "unpushed") {
        this.searchParams.status = 0;
      } else if (this.activeName === "pushed") {
        this.searchParams.status = 1;
      }
      this.getArticleList();
    },
    // 操作逻辑
    async TabhandleClick(val) {
      if (val.type === "edit") {
        // 打开编辑弹窗

        // 处理回填
        this.addPostId = val.val.postId;
        this.addPostExpectedPushTime = val.val.expectPushDate;
        this.handleAddPostIdSearch();

        this.dialogEditCircle = true;
        this.dialogAddPost = true;
      } else if (val.type === "check") {
        console.log("========", val.val);
        this.circleForm = val.val;
        this.dialogSetCircle = true;
        // this.circleForm.communityPicUrl = url.replace(imgHost, "");
      } else if (val.type === "delete") {
        // 删除
        jdh_qz_man_widget_post_update({
          postId: val.val.postId,
          delete: true,
        })
          .then((res) => {
            console.log("==== addddd", res);
            res && this.$message.success("成功");
            this.getArticleList();
          })
          .catch((res) => {
            this.$message.error(res.msg);
          });
        // this.circleForm.communityPicUrl = url.replace(imgHost, "");
      }
      this.getArticleList();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.$refs?.table?.concelEditSort?.();
      this.getArticleList("pageChange");
    },
    //获取文章列表
    getArticleList(type) {
      console.log(this.selectList, "pppppppppppp");
      let params = {
        // tenantId: this.$commonJs.getTenantId(),
        tenantId: parseInt(this.$route.query.tenantid),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        title: this.searchParams.title,
        auditStatus: "",
        postIds: this.searchParams.postIds,
        communityIds: this.searchParams.communityIds,
        titleKeyword: this.searchParams.titleKeyword,
        contentKeyword: this.searchParams.contentKeyword,
        authorPin: this.searchParams.authorPin,
        status: this.searchParams.status,
      };
      jdh_qz_man_widget_post_page(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          item.modPushTime = this.formatDate(item.pushTime);
          item.modStatus = item.status == 1 ? "已推送" : "未推送";
          if (item.status == 0) {
            item.auditStatusCheck = "未推送";
          } else if (item.status == 1) {
            item.auditStatusCheck = "已推送";
          }
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "contentReviewOnOffLine",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 5,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg" && item?.checkbox == "common") {
                return true;
              }
              return false;
            }
          );
          // console.log(cfgArray, 'contentAudit<----来了哥----->cfgArray');
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          let fileterArray = [];
          let allShowSearchArr = [];
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('默认id', 'itemSelectedIDs========>');
                this.checkList = item?.selectedIDs;
              }
            }
          });

          // console.log(valueArray ,fileterArray, 'valueArray=====>|||||allShowSearchArr',allShowSearchArr);
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(valueArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList?.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(res, 'queryFloorList=====>|||||');
        })
        .catch((err) => {
          console.log("==== err", err);
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "1",
      }).then((res) => {
        if (res && res?.length > 0) {
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    viewImage(url) {
      this.currentImageUrl = url;
      this.dialogVisible = true;
    },
    handleReset() {
      this.$refs?.table?.concelEditSort?.();
      this.activeName = "all";
      this.searchParams = {
        title: "",
        auditStatus: "",
        postIds: "",
        communityIds: "",
        titleKeyword: "",
        contentKeyword: "",
        authorPin: "",
      };
      this.searchParams.auditStatus = "";
      jdh_qz_man_widget_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        // communityId:this.searchParams.communityId,
        title: this.searchParams.title,
        auditStatus: "",
        postIds: this.searchParams.postIds,
        communityIds: this.searchParams.communityIds,
        titleKeyword: this.searchParams.titleKeyword,
        contentKeyword: this.searchParams.contentKeyword,
        authorPin: this.searchParams.authorPin,
        status: this.searchParams.status,
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          item.modPushTime = this.formatDate(item.pushTime);
          item.modStatus = item.status == 1 ? "已推送" : "未推送";
          if (item.status == 0) {
            item.auditStatusCheck = "未推送";
          } else if (item.status == 1) {
            item.auditStatusCheck = "已推送";
          }
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        if (type != "pageChange" && this.isSelected) {
          this.isSelected = false;
        }
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },
    handleSearch() {
      if (this.activeName == "unpushed") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName == "pushed") {
        this.searchParams.auditStatusCheck = 1;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      this.$refs?.table?.concelEditSort?.();
      const params = {
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        title: this.searchParams.title,
        auditStatus: "",
        postId: this.searchParams.postIds,
        communityId: this.searchParams.communityIds,
        titleKeyword: this.searchParams.titleKeyword,
        contentKeyword: this.searchParams.contentKeyword,
        pushStartTime: utils.isEmpty(this.searchParams.pushDate)
          ? null
          : utils.timetamp(Number(this.searchParams.pushDate[0])),
        pushEndTime: utils.isEmpty(this.searchParams.pushDate)
          ? null
          : utils.timetamp(Number(this.searchParams.pushDate[1])),
        expectPushStartDate: utils.isEmpty(this.searchParams.expectPushDate)
          ? null
          : utils.timetamp(Number(this.searchParams.expectPushDate[0])),
        expectPushEndDate: utils.isEmpty(this.searchParams.expectPushDate)
          ? null
          : utils.timetamp(Number(this.searchParams.expectPushDate[1])),
        authorPin: this.searchParams.authorPin,
        status: this.searchParams.status,
      };
      console.log("params", params);
      jdh_qz_man_widget_post_page(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          item.submitTime = this.formatDate(item.submitTime);
          item.modPushTime = this.formatDate(item.pushTime);
          item.modStatus = item.status == 1 ? "已推送" : "未推送";
          if (item.status == 0) {
            item.auditStatusCheck = "未推送";
          } else if (item.status == 1) {
            item.auditStatusCheck = "已推送";
          }
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;

        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },
    handleInitSearch(data) {
      if (this.searchParams.auditStatus == "未推送") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.searchParams.auditStatus == "已推送") {
        this.searchParams.auditStatusCheck = 1;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      jdh_qz_man_widget_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        title: this.searchParams.title,
        auditStatus: "",
        postId: this.searchParams.postIds,
        communityId: data,
        titleKeyword: this.searchParams.titleKeyword,
        contentKeyword: this.searchParams.contentKeyword,
        authorPin: this.searchParams.authorPin,
        status: this.searchParams.status,
      })
        .then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            item.submitTime = this.formatDate(item.submitTime);
            item.modPushTime = this.formatDate(item.pushTime);
            item.modStatus = item.status == 1 ? "已推送" : "未推送";
            if (item.status == 0) {
              item.auditStatusCheck = "未推送";
            } else if (item.status == 1) {
              item.auditStatusCheck = "已推送";
            }
            this.tableData.tableList.push(item);
          });
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
          if (type != "pageChange" && this.isSelected) {
            this.isSelected = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    getBusinessId(key) {
      switch (key) {
        case 287:
          return 359;
        case 290:
          return 320;
        case 484:
          return 580;
        case 492:
          return 611;
        case 501:
          return 618;
        default:
          return 320;
      }
    },
    handleAddPost() {
      if (!this.addPostId || !this.addPostIdSearch?.[0]?.postId) {
        this.$message.error("请正确填写新增帖子id");
      } else {
        jdh_qz_man_widget_post_update({
          postId: this.addPostIdSearch?.[0]?.postId,
          expectPushDate: utils.isEmpty(this.addPostExpectedPushTime)
            ? null
            : utils.timetamp(Number(this.addPostExpectedPushTime)),
        })
          .then((res) => {
            console.log("==== addddd", res);
            res && this.$message.success("成功");
            this.addPostId = "";
            this.addPostIdSearch = [];
            this.dialogAddPost = false;
            this.dialogEditCircle = false;
            this.getArticleList();
          })
          .catch((res) => {
            this.$message.error(res.msg);
          });
      }
    },
    handleAddPostIdSearch() {
      jdh_qz_man_post_page({
        tenantId: parseInt(this.$route.query.tenantid),
        pageNo: 1,
        pageSize: 10,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        postIds: this.addPostId,
        status: 1,
      })
        .then((res) => {
          console.log("==== jdh_qz_man_post_page", res.data);
          if (res.data?.length == 1) {
            this.addPostIdSearch = res.data;
          } else {
            this.addPostIdSearch = [];
          }
        })
        .catch((err) => {
          console.log("==== error", err);
          this.$message.error(err.msg);
          this.addPostIdSearch = [];
        });
    },
    handleInitAddPost() {
      this.dialogAddPost = true;
      this.dialogEditCircle = false;
      this.addPostId = "";
      this.addPostExpectedPushTime = "";
      this.addPostIdSearch = [];
    },
    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this, 5);
    },
    // 导入商品
    async uploadCategoryExl() {
      console.log("==== uploadCategoryExl");
      let file = this.fileName;
      if (file == "" || !file) {
        this.$message.error("请选择上传的文件");
        return false;
      } else {
        this.uploadShow = true;
        this.$message({
          message: "文件上传中，请勿刷新页面和关闭窗口！",
          type: "warning",
        });
      }
      jdh_qz_man_widget_post_import({
        base64Data: this.fileBase64,
      })
        .then((res) => {
          console.log("jdh_qz_man_widget_post_import", res);
          if (res?.data == 0) {
            console.log("==== ", res);
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.getArticleList();
          } else if (res == 1) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "活动已关联200条帖子",
              type: "error",
            });
          } else if (res == 2) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "上传超过200条帖子",
              type: "error",
            });
          } else if (res == 3) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "请按照模版字段上传",
              type: "error",
            });
          } else if (res == 4) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "请按照模版字段类型上传",
              type: "error",
            });
          } else if (res == 5) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "上传文件中含相同帖子",
              type: "error",
            });
          } else if (res == 6) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "请核对帖子信息是否正确",
              type: "error",
            });
          } else if (res == 7) {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "请确认上传的帖子均审核通过",
              type: "error",
            });
          } else {
            this.uploadShow = false;
            this.dialogMultiImport = false;
            this.fileName = null;
            this.$message({
              message: "上传失败",
              type: "error",
            });
          }
        })
        .catch((e) => {
          if (!e.success) {
            this.$message.error(e?.msg || "上传失败, 请检查网络或文件");
            this.uploadShow = false;
          }
          console.log(e, "ppppppp=======>");
        });
    },
    // 下载模板
    downloadCategoryExl() {
      window.location.href =
        "https://storage.360buyimg.com/tianxiuquan.org/%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E5%B8%96%E5%AD%90%E6%8E%A8%E9%80%81%E6%97%A5%E6%9C%9F%E6%A8%A1%E6%9D%BF.xlsx";
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;

  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
</style>
